import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>
          <span><p>Hi!</p></span>
          <span><p>I'm Graham,</p></span>
          <span><p>Full Stack Web Developer.</p></span>
        </h1>
      </header>
    </div>
  );
}

export default App;
